var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "verify-wrap" }, [
    _c("div", { staticClass: "head" }, [
      _c("div", { staticClass: "back", on: { click: _vm.back } }),
      _vm._v(" " + _vm._s(_vm.$t("input_code")) + " "),
    ]),
    _c(
      "div",
      { staticClass: "tips" },
      [
        _vm._v(
          " " +
            _vm._s(
              _vm.$t("send", {
                0:
                  Number(_vm.query.bind_type) === _vm.BIND_TYPES.EMAIL
                    ? _vm.query.email
                    : `+${_vm.query.csc} ${_vm.query.mobile}`,
              })
            ) +
            " "
        ),
        _vm.count > 0
          ? [_c("span", [_vm._v(_vm._s(`${_vm.count}s`))])]
          : [
              _c(
                "span",
                {
                  staticClass: "try-again",
                  on: {
                    click: function ($event) {
                      return _vm.reSend()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("send_again")))]
              ),
            ],
      ],
      2
    ),
    _c(
      "div",
      { staticClass: "code-wrap" },
      [
        _vm.$utils.isPC
          ? _c("Code", {
              attrs: { code: _vm.code },
              on: { complete: _vm.completeCode },
              model: {
                value: _vm.isFinish,
                callback: function ($$v) {
                  _vm.isFinish = $$v
                },
                expression: "isFinish",
              },
            })
          : _c("CodeM", {
              attrs: { code: _vm.code },
              on: { complete: _vm.completeCode },
              model: {
                value: _vm.isFinish,
                callback: function ($$v) {
                  _vm.isFinish = $$v
                },
                expression: "isFinish",
              },
            }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "btns" },
      [
        _c(
          "Button",
          {
            attrs: { type: "warning", disabled: !_vm.isFinish },
            on: {
              click: function ($event) {
                return _vm.login()
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("login")) + " ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }